<template lang="html">
    <section class="list-orders">
        <div class="">
            <h1 class="title primary-text">{{ $t("eStore.title") }}</h1>
            <div class="row">
                <div v-if="showMsgListOrder"><p style="color: red;">Liste vide</p></div>
                <div v-if="hideArray">
                    <p style="color: red;">Contactez votre admin, Error {{ getOrdersList.code }}</p>
                </div>
                <div class="col-md-12 col-xs-12 order-md-2 detail-content">
                    <table class="table table-hover table-detail" v-if="!hideArray">
                        <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">{{ $t("eStore.name") }}</th>
                                <th scope="col">{{ $t("eStore.brand") }}</th>
                                <th scope="col">{{ $t("eStore.zone") }}</th>
                                <th scope="col">{{ $t("eStore.status") }}</th>
                                <th scope="col">{{ $t("eStore.last") }}</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="order in getOrdersList">
                                <td scope="row">{{ order.id }}</td>
                                <td>{{ order.name }}</td>
                                <td>{{ order.brand.name }}</td>
                                <td>{{ order.zone.name }}</td>
                                <td>{{ getTranslate(order.status.name) }}</td>
                                <td>{{ order.modifiedDate }}</td>
                                <td class="text-right">
                                    <router-link :to="{ path: '/list-orders/detail/' + order.id }" class="btn"
                                        >{{ $t("eStore.details") }}
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'list-orders',
    props: [],
    mounted () {
    },
    data () {
        return {
            showMsgListOrder: false,
            hideArray: false
        }
    },
    methods: {
        ...mapActions({
            listOrders: 'ordersStore/listOrders'
        })
    },
    created () {
        if (this.listOrders() && this.listOrders() !== undefined) {
            this.showMsgListOrder = false
            this.listOrders()
        } else if (this.getOrdersList.code === 400) {
            this.hideArray = true
        } else {
            this.showMsgListOrder = true
        }
    },
    computed: {
        ...mapGetters({
            getOrdersList: 'ordersStore/getOrdersList'
        })
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.list {
    &-orders {
        width: 100%;
        & .title {
            width: 100%;
            text-transform: uppercase;
            font-size: 15px;
            font-weight: normal;
            font-size: xx-large;
            margin-bottom: 10px;
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        }
        & .table {
            & thead {
                & th {
                    border: none;
                    background-color: #005f7f;
                    color: white;
                    text-transform: uppercase;
                    font-size: 13px;
                    padding: 1.1rem;
                    text-align: center;
                    &:first-child {
                        width: 50px;
                    }
                }
            }
            & tbody {
                & tr {
                    transition: all 0.3s ease;
                    -o-transition: all 0.3s ease;
                    -webkit-transition: all 0.3s ease;
                    border-bottom: 1px solid #e5e5e5;
                    background-color: #ffffff;
                    &:hover {
                        background-color: rgba(0, 0, 0, 0.05);
                        & td {
                            color: #343a40;
                            & a {
                                color: #343a40;
                            }
                        }
                    }
                }
                & td {
                    border: none;
                    padding-top: 20px;
                    padding-bottom: 20px;
                    text-align: center;
                    color: #6f6f6f;
                    & .btn-list {
                        color: #ffffff;
                        background: #005f7f;
                        padding: 5px 20px;
                        text-decoration: none;
                        &:hover {
                            background: #0085b2;
                        }
                    }
                }
            }
            &-detail {
                border-collapse: collapse;
                border-spacing: 0;
                border: 1px solid #005f7f;
                border-radius: 10px;
                overflow: hidden;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// ListOrders.vue?41704d34